import React from 'react';
import Dropdown from '../dropdown/dropdown';
import './styles.css';
import printIcon from '../../images/Share.svg';

const ResultsControlBar = ({ 
  sortOption = 'Distance',
  onSortChange = () => {},
  // Single combined "Print or email results" action — the parent opens PrintEmailModal.
  onPrintEmailClick = () => {}
}) => {
  // console.log('🎛️ ResultsControlBar rendered with sortOption:', sortOption);

  // Sort options available to user
  const sortOptions = [
    { value: 'Distance', label: 'Distance' },
    { value: 'Name (A–Z)', label: 'Name (A–Z)' },
    { value: 'Name (Z–A)', label: 'Name (Z–A)' }
  ];

  // console.log('📋 Sort options:', sortOptions);

  // Function to announce changes to screen readers
  const announceToScreenReader = (message) => {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    announcement.style.position = 'absolute';
    announcement.style.left = '-10000px';
    announcement.style.width = '1px';
    announcement.style.height = '1px';
    announcement.style.overflow = 'hidden';
    
    document.body.appendChild(announcement);
    
    // Remove after announcement
    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 1000);
  };

  const handleSortChange = (e) => {
    const newSortOption = e.target.value;
    onSortChange(newSortOption);
    
    // Announce the sort change
    announceToScreenReader(`Results sorted by ${newSortOption}`);
  };

  return (
    <div className="results-control-bar">
      {/* Print and Email Section — on mobile this renders FIRST (see .results-control-bar
          flex-direction:column in the mobile media query) so it forms its own single row
          directly between the map (ResultsSummary, rendered just before this component)
          and the "Sort by" row below. Previously this whole section was hidden outright on
          mobile via `{!isMobile && ...}`, so the Print/Email links were simply lost/
          inaccessible on mobile instead of just being repositioned. */}
      
      {/* Sort Section */}
      <div className="sort-section">
        <label htmlFor="sort-dropdown" id="sort-dropdown-label" className="sort-label">
          Sort by:
        </label>
        <Dropdown
          id="sort-dropdown"
          className="sort-dropdown"
          value={sortOption}
          onChange={handleSortChange}
          options={sortOptions}
          aria-label="Sort results by"
          aria-labelledby="sort-dropdown-label"
        />
      </div>

      <div className="actions-section">
        <button 
          className="action-button"
          onClick={onPrintEmailClick}
          aria-label="Print or email results"
          aria-haspopup="dialog"
        >
          <img 
            src={printIcon} 
            alt="" 
            className="action-icon"
          />
          <span className="action-text">Print or email results</span>
        </button>
      </div>
    </div>
  );
};

export default ResultsControlBar;